/* import __COLOCATED_TEMPLATE__ from './responsive-picture.hbs.js'; */
var _dec, _dec2, _dec3, _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { assert } from '@ember/debug';
import { computed } from '@ember/object';
import Component from '@glimmer/component';
let ResponsivePicture = (_dec = computed('this.args.sources.S'), _dec2 = computed('this.args.sources.M'), _dec3 = computed('this.args.sources.L'), (_class = class ResponsivePicture extends Component {
  get srcsetSmall() {
    return this.getSrcset('S');
  }
  get srcsetMedium() {
    return this.getSrcset('M');
  }
  get srcsetLarge() {
    return this.getSrcset('L');
  }
  getSrcset(breakpoint) {
    const breakpointSrc = this.args.sources[breakpoint];
    if (!breakpointSrc) {
      return '';
    }
    assert(`You must pass at least one image path with a \`1x\` key to \`sources.${breakpoint}\``, breakpointSrc['1x']);
    const srcset = [`${breakpointSrc['1x']} 1x`];
    if (breakpointSrc['2x']) {
      srcset.push(`${breakpointSrc['2x']} 2x`);
    }
    return srcset.join(', ');
  }
}, (_applyDecoratedDescriptor(_class.prototype, "srcsetSmall", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "srcsetSmall"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "srcsetMedium", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "srcsetMedium"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "srcsetLarge", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "srcsetLarge"), _class.prototype)), _class));
export { ResponsivePicture as default };